<app-header></app-header>
<div class="container-fluid mat-100">
  <div class="col-lg-12 middle-content-hgt " style="background-color: #f2f2f7;">
    <div class="bb-2 clearfix">
      <div class="col-lg-12 bg-light-blue no-padding">
        <div class="row">
          <div class="col-12">
            <h5 class="pull-left pt-2 pl-3 pr-3">Dashboard</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 " style="padding:20px;">
        <!--button *ngIf="!userInfo" id="handle-sign-in" (click)='authorizationService.authorize()'>SIGN IN</button-->
        <button *ngIf="!userInfo" (click)="Authorize()">Sign in</button>
        <div *ngIf='authorized'>
          <div>
            <title>User information</title>
            <img *ngIf="userInfo?.picture" src='{{userInfo?.picture}}' />
          </div>
          <div *ngIf='!userInfo'>
            <h4>Authorized</h4>
            <p>The user has been authorized by the Identity Provider, but has no user information to display</p>
          </div>
          <div *ngIf='userInfo'>
            <h4>Authorized</h4>
            <p>The user has been authorized by the Identity Provider, with the following additional user information.
            </p>
            <pre class='json-display'>{{ userInfo | json }}</pre>
          </div>
          <button id="handle-sign-out" (click)='authorizationService.signOut()'>SIGN OUT</button>
        </div>
      </div>
    </div>
  </div>